export default __webpack_public_path__ + "static/media/004-analytics.a6725fb7.svg";